import { render, staticRenderFns } from "./Preview2.vue?vue&type=template&id=47c459ce&"
import script from "./Preview2.vue?vue&type=script&lang=ts&"
export * from "./Preview2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports